import type { ReactElement } from 'react'
import styles from './DescriptionWithIcon.module.css'

type DescriptionWithIconProps = {
  title: string
  description: string
  icon: ReactElement
}

export const DescriptionWithIcon = ({ title, description, icon }: DescriptionWithIconProps) => (
  <div className={styles.step}>
    <div className={styles.iconContainer}>{icon}</div>
    <h4 className={styles.stepHeading}>{title}</h4>
    <p className={styles.stepText}>{description}</p>
  </div>
)
